import React from 'react';
import styles from './Header.module.css';
import { useNavigate } from 'react-router-dom';

function Header({ title = 'ChenBaby', actions = null, user = null, showNavigation = true }) {
  const navigate = useNavigate();

  // 处理导航点击
  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  // 如果没有传递 actions 且 showNavigation 为 true，则显示默认的导航按钮
  const renderDefaultActions = () => {
    if (actions) return actions;

    if (!showNavigation) return null;

    return (
      <>
        {/* 首页 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/office')}
          title="首页"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-shouye3"></use>
          </svg>
         
        </button>

        {/* 记账 - 仅管理员可见 */}
        {user?.permission_level === 'Administrator' && (
          <button 
            className={styles.navBtn}
            onClick={() => handleNavigation('/accounting/*')}
            title="记账"
          >
            <svg className={styles.navIcon} aria-hidden="true">
              <use xlinkHref="#icon-icon-zhangben"></use>
            </svg>
           
          </button>
        )}

        {/* 听歌 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/music/home')}
          title="听歌"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-kefu"></use>
          </svg>
         
        </button>

        {/* 办公 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/work/quickcopy')}
          title="办公"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-zdxmzs"></use>
          </svg>
          
        </button>

        {/* 聊天 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/wechat/')}
          title="聊天"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-duihuaxinxi"></use>
          </svg>
           
        </button>

        {/* 主题设置 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/wechat/systemthemesettings')}
          title="主题设置"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-zhuti1"></use>
          </svg>
          
        </button>

        {/* 用户信息 */}
        {user && (
          <div className={styles.userInfo}>
            <span className={styles.username}>
              {user.username || user.email || '用户'}
            </span>
          </div>
        )}

        {/* 退出登录 */}
        <button 
          className={styles.navBtn}
          onClick={() => handleNavigation('/auth')}
          title="退出"
        >
          <svg className={styles.navIcon} aria-hidden="true">
            <use xlinkHref="#icon-bianzu"></use>
          </svg>
         
        </button>
      </>
    );
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <svg className={styles.headerIcon} aria-hidden="true">
          <use xlinkHref="#icon-gongzuoshi"></use>
        </svg>
        <h1 className={styles.headerTitle}>{title}</h1>
      </div>

      <div className={styles.headerActions}>
        {renderDefaultActions()}
      </div>
    </header>
  );
}

export default Header;